import { useMinStaySettings } from '@pages/Client/hooks/useMinStaySettings';
import { MinStaySettings } from '@common/api/minstay/types';

export const useHandleMinStaySettings = () => {
  const { minStaySettingsQuery } = useMinStaySettings();

  const prepareMinStaySettings = async (minStayDates: MinStaySettings['dates']) => {
    let latestMinStaySettings: MinStaySettings | undefined;
    try {
      latestMinStaySettings = await minStaySettingsQuery.refetch().then((res) => res.data);

      if (!latestMinStaySettings) {
        throw new Error('Failed to fetch latest min stay settings');
      }

      const newMinStaySettings = {
        ...latestMinStaySettings,
        dates: minStayDates
      };

      return {
        minStaySettingsForAPI: newMinStaySettings
      };
    } catch (error) {
      console.error('Failed to prepare min stay settings:', error);
      return {
        minStaySettingsForAPI: { dates: minStayDates, minstay: latestMinStaySettings?.minstay }
      };
    }
  };

  return {
    prepareMinStaySettings
  };
};
